<global-footer>
  Quản lý Công trình Á Đông <i nz-icon nzType="copyright" class="mx-sm"></i> {{ year }} Phát triển bởi <a href="https://zamio.vn">Zamio</a>
</global-footer>
